var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('v-text-field',_vm._g(_vm._b({ref:"element",class:[
      'base-text-field',
      {
        'persistent-border': _vm.isPersistentBorder,
      }],attrs:{"dense":"","outlined":"","clear-icon":_vm.clearIcon}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }